var toString = {}.toString;

var isType = function isType(value, type) {
  return toString.call(value) === '[object ' + type + ']';
};

module.exports = isType;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-type.js
// module id = 16
// module chunks = 0